<div id="zone-selector">

    <!-- todo take out true -->
    <mat-expansion-panel #panel [expanded]="isExpanded">
        <mat-expansion-panel-header class="border">
            <mat-panel-title>
                {{ title }}
            </mat-panel-title>
        </mat-expansion-panel-header>


        <app-search-input [placeholder]="'search for zone or category name' | i18next: { format: 'capitalize' }" (inputChanged)="inputChanged($event)"></app-search-input>

        <div class=flex-container>

            <!-- left side -->
            <div>
                <div style="visibility: hidden" aria-hidden="true">Some text for hackiness to make boxes look event</div>
                <div class="checkboxes border default-height">
                    <ngx-skeleton-loader count="5" *ngIf="categoriesLoading"></ngx-skeleton-loader>
                    <ng-container *ngIf="categories?.length">
                        <div class="categories" *ngFor="let cat of displayedCats">
                            <ng-container>
                                <mat-expansion-panel class="category"
                                [expanded]="cat.expanded"
                                (opened)="opened(cat)"
                                (closed)="closed(cat)"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <span>{{ cat.name }}</span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ngx-skeleton-loader count="3" *ngIf="zonesLoading"></ngx-skeleton-loader>

                                    <div
                                        class="category-panel"
                                        role="listbox"
                                        style="outline: none;"
                                        tabindex="0"
                                        #categoryPanel
                                        (focus)="focusFirstOption(categoryPanel)"
                                        (keydown)="onZoneKeydown($event, categoryPanel)"
                                    >
                                        <ng-container *ngIf="cat?.zones?.length; else noZones">
                                            <mat-checkbox
                                                tabindex="-1"
                                                #selectAllBox
                                                *ngIf="cat?.zones?.length > 1"
                                                class="select-all-checbox"
                                                [checked]="cat.checked"
                                                (change)="selectAllCheckboxChange(cat, $event)"
                                                >
                                                <b>{{ "select all" | i18next: { format: "capitalize" } }}</b>
                                                </mat-checkbox>
                                                <mat-checkbox tabindex="-1" *ngFor="let zone of cat?.zones"
                                                (change)="change(zone, $event, cat)"
                                                [checked]="zone?.checked"
                                                >
                                                    {{ zone.name}}
                                            </mat-checkbox>
                                        </ng-container>
                                    </div>
                                    <ng-template #noZones><ng-container *ngIf="!zonesLoading">{{ "this category has no zones" | i18next }}</ng-container></ng-template>
                                </mat-expansion-panel>
                            </ng-container>
                        </div>

                    </ng-container>
                    <span *ngIf="!displayedCats.length">{{ "no zones matching this criteria" | i18next }}</span>
                </div>
            </div>


            <!-- right side -->
            <div>
                <p>{{ "count zones selected" | i18next: { count: _filterZones(this.selectedZones).length } }}</p>
                <div class="selected-zones border default-height">
                    <ng-template #noZonesSelected>{{ "no zones selected" | i18next: { format: "capitalize" } }}</ng-template>
                    <ng-container *ngIf="selectedCategories?.length; else noZonesSelected">
                        <div class="categories" *ngFor="let cat of selectedCategories">
                            <ng-container>
                                <mat-expansion-panel
                                    *ngIf="cat?.zones?.length"
                                    class="category"
                                    [expanded]="true"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <span>{{ cat.name }}</span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <ul
                                        #selectedPanel
                                        role="listbox"
                                        style="outline: none;"
                                        tabindex="0"
                                        (focus)="focusFirstSelectedOption(selectedPanel)"
                                        (keydown)="onSelectedZoneKeydown($event, selectedPanel)"
                                    >
                                        <li *ngFor="let zone of cat.zones" class="list-item">
                                            <div>{{ zone?.name}}</div>
                                            <mat-icon (click)="removeZone(zone)" (keydown.enter)="removeZone(zone)"
                                                (keydown.space)="$event.preventDefault(); removeZone(zone)" tabindex="-1" role="button"
                                                [attr.aria-label]="'remove zone name' | i18next: { name: zone?.name, interpolation: { escapeValue: false } }" style="cursor: pointer;">delete</mat-icon>
                                        </li>
                                    </ul>

                                    <ng-template #noZones>
                                        <ng-container>
                                            {{ "this category has no zones" | i18next }}
                                        </ng-container>
                                    </ng-template>
                                </mat-expansion-panel>
                            </ng-container>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
        <div class="button-container" style="display: flex; gap: 1em; justify-content: flex-end">
            <app-action-button
                title="cancel"
                (buttonClicked)="cancelClicked()"
            ></app-action-button>
            <app-action-button
                title="apply"
                (buttonClicked)="applyClicked()"
            ></app-action-button>
        </div>

    </mat-expansion-panel>
</div>
